var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path, _rect72, _rect73, _rect74, _rect75, _rect76;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 26,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 66,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 6.34375,
    y: 29.4512,
    width: 23.0986,
    height: 98.1582,
    rx: 2,
    transform: "rotate(-90 6.34375 29.4512)",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0318 19.1783L55.4568 15.0973C55.4102 14.976 55.3612 14.836 55.3098 14.6773C55.2585 14.514 55.2095 14.3413 55.1628 14.1593C55.0648 14.5373 54.9645 14.8523 54.8618 15.1043L53.2868 19.1783H57.0318ZM59.8598 22.9023H58.8098C58.6885 22.9023 58.5905 22.872 58.5158 22.8113C58.4412 22.7507 58.3852 22.6737 58.3478 22.5803L57.4098 20.1583H52.9088L51.9708 22.5803C51.9428 22.6643 51.8892 22.739 51.8098 22.8043C51.7305 22.8697 51.6325 22.9023 51.5158 22.9023H50.4658L54.4768 12.8713H55.8488L59.8598 22.9023Z",
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 105.099,
    height: 5.77465,
    fill: "#D9D9D9"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    y: 76.2266,
    width: 105.099,
    height: 5.77465,
    fill: "#D9D9D9"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 5.77465,
    height: 82,
    fill: "#D9D9D9"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 105.098,
    width: 5.77465,
    height: 44.4648,
    fill: "#D9D9D9"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 105.098,
    y: 70.4512,
    width: 5.77465,
    height: 11.5493,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight);
export default __webpack_public_path__ + "static/media/straight.b3a92993def0412a4b369d717cd86351.svg";
export { ForwardRef as ReactComponent };